import React from "react";
import LegalLayout from "../../components/LegalLayout";
import { hotel } from "../../mock";

const Privacy = () => (
  <LegalLayout title="Gizlilik Politikası" updated="Haziran 2026">
    <p>
      Safranbolu Çelebi Otel olarak kişisel verilerinizin gizliliğine büyük önem
      veriyoruz. Bu Gizlilik Politikası; web sitemizi ziyaret ettiğinizde veya
      bizimle iletişime geçtiğinizde toplanan bilgilerin nasıl kullanıldığını,
      saklandığını ve korunduğunu açıklamaktadır.
    </p>

    <h2>1. Topladığımız Bilgiler</h2>
    <p>
      Sizinle iletişim kurabilmemiz ve rezervasyon taleplerinizi
      değerlendirebilmemiz için aşağıdaki bilgileri toplayabiliriz:
    </p>
    <ul>
      <li>Ad, soyad ve iletişim bilgileri (telefon, e-posta)</li>
      <li>Rezervasyon talep detayları (giriş/çıkış tarihi, oda tipi, misafir sayısı)</li>
      <li>İletişim formu aracılığıyla ilettiğiniz mesaj içerikleri</li>
      <li>Site kullanımına ilişkin teknik veriler (çerezler aracılığıyla)</li>
    </ul>

    <h2>2. Bilgilerin Kullanım Amaçları</h2>
    <ul>
      <li>Rezervasyon taleplerinizi yanıtlamak ve konaklamanızı planlamak</li>
      <li>Sorularınıza ve taleplerinize geri dönüş sağlamak</li>
      <li>Hizmet kalitemizi ve web sitesi deneyimini iyileştirmek</li>
      <li>Yasal yükümlülüklerimizi yerine getirmek</li>
    </ul>

    <h2>3. Çerezler</h2>
    <p>
      Web sitemiz, deneyiminizi geliştirmek amacıyla çerezler kullanmaktadır.
      Çerezlerin nasıl kullanıldığına ve nasıl yönetebileceğinize ilişkin ayrıntılı
      bilgiye <a href="/cerez-politikasi">Çerez Politikası</a> sayfamızdan
      ulaşabilirsiniz.
    </p>

    <h2>4. Bilgilerin Paylaşımı</h2>
    <p>
      Kişisel verileriniz, açık rızanız olmaksızın üçüncü taraflarla ticari amaçla
      paylaşılmaz veya satılmaz. Verileriniz yalnızca yasal zorunluluklar
      kapsamında veya hizmetin sunulabilmesi için gerekli olduğu ölçüde ilgili
      taraflarla paylaşılabilir.
    </p>

    <h2>5. Veri Güvenliği</h2>
    <p>
      Kişisel verilerinizi yetkisiz erişime, kayba ve kötüye kullanıma karşı korumak
      için makul teknik ve idari tedbirleri almaktayız. Ancak internet üzerinden
      yapılan hiçbir veri aktarımının %100 güvenli olmadığını hatırlatırız.
    </p>

    <h2>6. Haklarınız</h2>
    <p>
      6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) kapsamındaki haklarınıza
      ilişkin ayrıntılı bilgiye <a href="/kvkk">KVKK Aydınlatma Metni</a> sayfamızdan
      ulaşabilirsiniz.
    </p>

    <h2>7. Politika Değişiklikleri</h2>
    <p>
      Bu Gizlilik Politikası zaman zaman güncellenebilir. Güncel sürüm her zaman bu
      sayfada yayımlanır.
    </p>

    <h2>8. İletişim</h2>
    <p>
      Gizlilikle ilgili sorularınız için bizimle iletişime geçebilirsiniz:
      <br />
      <strong>E-posta:</strong> {hotel.email}
      <br />
      <strong>Telefon:</strong> {hotel.phones[0]}
      <br />
      <strong>Adres:</strong> {hotel.address}
    </p>
  </LegalLayout>
);

export default Privacy;
